/* eslint-disable default-param-last */
import { SHOW_CATEGORY_DETAILS } from 'actionTypes/categoryDetailsActionTypes';

const initialState = {
  status: false,
  selectedCategory: null,
};

const categoryDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_CATEGORY_DETAILS:
      return {
        ...state,
        status: action.payload.status,
        selectedCategory: action.payload.selectedCategory,
      };
    default:
      return state;
  }
};

export default categoryDetailsReducer;
